<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">
                                <h1>Wachtwoord vergeten?</h1>
                                <p class="text-muted"><br />Vul hier je e-mailadres in en klik op <i>Versturen</i><br /></p>
                                <div class="form-group">
                                    <b-input-group left="<i class='fa fa-user'></i>">
                                        <b-form-input type="email" placeholder="Account" v-model="user.account" name="account" v-validate="'required|email'" :class="{'form-control': true, 'is-invalid': errors.has('account') }"></b-form-input>
                                    </b-input-group>
                                    <span class="small text-danger" v-show="errors.has('account')">Vul je account (e-mailadres) in</span>
                                </div>
                                <div class="row"><br /></div>
                                <div class="row">
                                    <div class="col-6">
                                        <button type="button" class="btn btn-primary px-4" @click="versturen">Versturen</button>
                                    </div>
                                    <div class="col-6 text-right">
                                        <router-link :to="'/pages/login'">Terug naar aanmelden</router-link>
                                    </div>
                                </div>
                                <div class="small" ><br/><span v-show="goed">We hebben een e-mail met een nieuw wachtwoord verstuurd naar het opgegeven e-mailadres.</span></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../api/account';

export default {
    name: 'Login',
    data () {
        return {
            user: {
                account: process.env.USER,
            },
            goed: false,
        };
    },
    methods: {
        versturen () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    api.mailNewPassword(this.user.account).then(() => {
                            this.goed = true;
                        },
                        (error) => {
                        });
                } else {
                    // console.log(this.$validator.errors);
                }
            });
        },
    },
    computed: {
        versie () {
            return process.env.VERSIE;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/Vergeten.vue